import { UserField } from '@frontend/shared/components/UserField/UserField';
import { useDirectoryUsers } from '@frontend/shared/hooks/useDirectory';

export function ChannelEditorsSection({
  selectedIds,
  setSelectedIds,
  isReadOnly = false,
}: {
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  isReadOnly?: boolean;
}) {
  const allUsers = useDirectoryUsers();

  return (
    <div>
      <h3 className="text-sm font-semibold">Editors</h3>
      <p className="mt-1 text-xs text-gray-500">
        Editors assigned to this channel will receive case tracker updates for
        questions asked here.
      </p>
      {!isReadOnly && (
        <div className="mt-2 max-w-[480px]">
          <UserField
            placeholder="+Add Editor"
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            excludeDeleted
          />
        </div>
      )}
      {isReadOnly && (
        <div className="mt-2">
          {selectedIds.map((id) => {
            const user = allUsers.find((u) => u.id === id);
            return user ? (
              <p key={id} className="mb-1 text-sm">
                {user.name}
              </p>
            ) : null;
          })}
        </div>
      )}
    </div>
  );
}
